var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "u-calc-button u-calc-button--save",
      on: { click: _vm.showEmailModal },
    },
    [_c("p", [_vm._v("Email Your Savings")]), _vm._v(" "), _c("span")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }